module.exports = __webpack_public_path__ + "static/media/profile-bharathreddy.2fcca342.pdf";